<template>
  <default-layout>
     <v-layout wrap>
         <v-flex xs12>
             <expertrating-menu-bar></expertrating-menu-bar>
         </v-flex>

         <v-flex xs12 v-if="expertratings" class="pt-5">
             <expertrating-table :expertratings="expertratings"></expertrating-table>
         </v-flex>
     </v-layout>
  </default-layout>
</template>
<script>
import ExpertratingMenuBar from './_components/expertrating_menu.vue'
import ExpertratingTable from './_components/expertrating_table.vue'

export default {
  name: 'ExpertratingIndexPage',
  components: {
    ExpertratingMenuBar,
    ExpertratingTable
  },
  data () {
    return {
      expertratings: []
    }
  },
  methods: {
   
  },
  created () {
    this.$store.dispatch("get", "/review/experts").then(res => {
      this.expertratings = res.reviews;
    });
  }
}
</script>
